// empty array to prevent re-render
export const EMPTY_ARRAY = Object.freeze([]);
